<div>
  <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
    <img src="/assets/images/tutorialOverlayBttn.svg" />
  </button>
  <div class="header-controls split-flex">
    <h3>
      <fa-icon [icon]="enrollIcon"/>
      Manage Co-Teachers
    </h3>
    <wf-school-admin-teacher-filter
      *ngIf="showTeacherFilter"
      (teacherChange)="onTeacherFilterChange()"
    ></wf-school-admin-teacher-filter>
  </div>
  <div class="alert alert-secondary message" style="background-color: rgba(211, 211, 211, .4) ;">
    <div class="icon">
      <fa-icon [icon]="infoIcon"></fa-icon>
    </div>
    <div>
      <div class="bold">Co-Teacher Access</div>
      <p>
        To grant Co-Teacher access to specific students, use the Students list on the left.
        Select the students you want to assign, then click the <span class="bold">Assign Selected Students</span>
        button to choose the Teacher who will receive access.
      </p>
      <p>
        To grant access to all your students, click the <span class="bold">Add Co-Teacher</span> button on the right,
        select the desired Teacher, and share access.
      </p>
    </div>
  </div>
  <div class="container margin-0">
    <!-- Left Column -->
    <div class="left-column">
      <div>
        <div class="report-section-header split-flex">
          <h5 class="results-report-header">
            <fa-icon [classes]="['print-hide']" [icon]="coTeacherIcon"></fa-icon> {{ studentListTitle }}
          </h5>
        </div>
        <div class="boxed-content">
          <div class="margin-top-10 margin-bottom-25">
            <div id="student-list-message" class="alert message" *ngIf="message"
                 [ngClass]="{ 'alert-danger': messageStatus === 'error', 'alert-success': messageStatus === 'success' }">
              <div class="icon">
                <fa-icon [icon]="successIcon" *ngIf="messageStatus === 'success'"></fa-icon>
                <fa-icon [icon]="errorIcon" *ngIf="messageStatus === 'error'"></fa-icon>
              </div>
              <div>
                <div class="bold">{{ messageTitle }}</div>
                {{ message }}
                <fa-icon [icon]="closeIcon" class="close-message" (click)="clearMessage()"></fa-icon>
              </div>
            </div>
            <div id="searchStudents">
              <input type="text" class="form-control" placeholder="Search Students..." [(ngModel)]="searchTerm" />
            </div>
            <div class="padding-top-10 flex column-gap-5">
              <button type="button" class="btn btn-success" [disabled]="!selectedStudents.size" (click)="openAssignStudentsDialog()" *ngIf="!isParentUser">
                <fa-icon [icon]="coTeacherIcon" *ngIf="!isAddingCoTeacher"></fa-icon>
                <fa-icon [icon]="loadingIcon" [spin]="true" *ngIf="isAddingCoTeacher"></fa-icon>
                Assign Selected Students <span *ngIf="selectedStudents.size">({{ selectedStudents.size }})</span>
              </button>
              <button type="button" class="btn clear-selection-button" [disabled]="!selectedStudents.size" (click)="clearStudentSelection()" *ngIf="!isParentUser">
                <fa-icon [icon]="clearSelectionIcon"></fa-icon>
                Clear Selection
              </button>
            </div>
          </div>
          <div class="student-list">
            <div *ngFor="let student of searchStudents()"
                 [ngClass]="{ 'student-item-selected': selectedStudents.has(student.userID), 'has-coteachers': hasCoTeachers(student.userID) }"
                 class="student-item">

              <div class="student-row">
                <div class="student-checkbox">
                  <input type="checkbox" [checked]="selectedStudents.has(student.userID)" [value]="student.userID" (change)="studentToggled(student.userID)" />
                </div>

                <!-- Existing student info display -->
                <div class="student-info">
                  <div class="student-name" (click)="studentToggled(student.userID)">{{student.firstName}} {{student.lastName}}</div>
                  <div *ngIf="hasCoTeachers(student.userID)" (click)="toggleStudentCoTeacherList(student.userID)" class="coteacher-indicator">
                    <fa-icon [icon]="selectedStudentForRevoke === student.userID ? collapseIcon : expandIcon"></fa-icon>
                    ({{ getStudentCoTeachers(student.userID).length }} co-teachers)
                  </div>
                </div>
              </div>

              <!-- Co-teacher list that shows when student is selected -->
              <div *ngIf="selectedStudentForRevoke === student.userID"
                   class="coteacher-list">
                <div class="coteacher-header">Direct Assignments</div>
                <div *ngFor="let teacher of getStudentCoTeachers(student.userID)"
                     class="coteacher-item">
                  <span>{{teacher.fullName}}</span>
                  <button (click)="revokeCoTeacherAccessForStudent(teacher.userID, student.userID)"
                          [disabled]="isAddingCoTeacher"
                          class="revoke-button flex">
                    <fa-icon [icon]="removeCoTeacherIcon"></fa-icon>
                    Revoke Access
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="right-column">
      <div class="report-section-header split-flex">
        <h5 class="results-report-header">
          <fa-icon [classes]="['print-hide']" [icon]="coTeacherIcon"></fa-icon> Co-Teacher List
        </h5>
      </div>
      <div class="boxed-content" id="co-teacher-list">
        <div class="margin-top-10 margin-bottom-10">
          <button type="button" class="btn btn-sm btn-success margin-left-5" [disabled]="isDeleting" (click)="openAddCoTeacherDialog()" *ngIf="!isParentUser">
            <fa-icon [icon]="coTeacherIcon" *ngIf="!isAddingCoTeacher"></fa-icon>
            <fa-icon [icon]="loadingIcon" [spin]="true" *ngIf="isAddingCoTeacher"></fa-icon>
            Add Co-Teacher
          </button>
        </div>
        <table *ngIf="!isParentUser && teachersWithAllAccess.length > 0" class="report-table">
          <thead>
          <tr>
            <th>Name</th>
            <th class="print-hide"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let teacher of teachersWithAllAccess">
            <td style="vertical-align: middle ;">{{ teacher.fullName }}</td>
            <td style="vertical-align: middle ;" class="print-hide center-space-flex">
              <button type="button" class="btn btn-sm btn-danger" title="Revoke Access" (click)="revokeCoTeacherAccess(teacher.userID)"><fa-icon
                [icon]="removeCoTeacherIcon"></fa-icon></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Dialog window for assigning 'Co-Teacher' status to a teacher for selected student(s) -->
<div class="assign-confirm-dialog-background" *ngIf="showAddCoTeacherDialog"></div>
<div class="modal-dialog" role="document" style="z-index: 1001;" *ngIf="showAddCoTeacherDialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5>
        <fa-icon [icon]="addTeacherIcon"></fa-icon>
        Grant Co-Teacher Access for All Students
      </h5>
    </div>
    <div class="modal-body">
      <div class="alert alert-secondary">
        Select the Teacher to grant Co-Teacher access for all of your students
      </div>
      <ng-select id="teacher-search" class="print-hide" [items]="filteredTeachers" bindLabel="fullName"
        bindValue="userID" [(ngModel)]="selectedCoTeacherId" (change)="setSelectedCoTeacher($event.userID)"
        placeholder="Select a teacher">
      </ng-select>
    </div>
    <div class="modal-footer margin-top-10 column-gap-5">
      <button class="btn btn-success" [disabled]="!selectedCoTeacherId"
              (click)="assignCoTeacherAccessToAllStudents(selectedCoTeacherId)">
        <fa-icon [icon]="addTeacherIcon"></fa-icon>
        Add Co-Teacher
      </button>
      <button class="btn btn-secondary" (click)="hideCoTeacherDialog()">
        <fa-icon [icon]="backIcon"></fa-icon>
        Cancel
      </button>
    </div>
  </div>
</div>

<!-- Dialog window for assigning student(s) to a teacher with 'Co-Teacher' status -->
<div class="assign-confirm-dialog-background" *ngIf="showAssignStudentsDialog"></div>
<div class="modal-dialog" role="document" style="z-index: 1001;" *ngIf="showAssignStudentsDialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5>
        <fa-icon [icon]="addTeacherIcon"></fa-icon>
        Grant Co-Teacher Access for Selected Students
      </h5>
    </div>
    <div class="modal-body">
      <div class="alert alert-secondary">
        Select the Teacher to grant Co-Teacher access for the selected students
      </div>
      <ng-select id="teacher-search" class="print-hide" [items]="filteredTeachers" bindLabel="fullName"
        bindValue="userID" [(ngModel)]="selectedCoTeacherId" (change)="setSelectedCoTeacher($event.userID)"
        placeholder="Select a teacher">
      </ng-select>
    </div>
    <div class="modal-footer margin-top-10 column-gap-5">
      <button class="btn btn-success" type="button" [disabled]="!selectedCoTeacherId"
        (click)=" assignCoTeacherToSelectedStudents()">
        <fa-icon [icon]="addTeacherIcon"></fa-icon>
        Assign
      </button>
      <button class="btn btn-secondary" type="button" (click)="hideAssignStudentsDialog()">
        <fa-icon [icon]="backIcon"></fa-icon>
        Cancel
      </button>
    </div>
  </div>
</div>
